// extracted by mini-css-extract-plugin
export default {"text":"ChildrenModeFairyForestGreeting_text__2NOLy"};